<template>
    <div>
        <div v-if="createError">
            <call-error />
        </div>
        <div v-else-if="currentCall">
            <call-dialog />
        </div>
        <div v-else-if="callPreview">
            <call-preview />
        </div>
        <div v-else>
            <generic-loading />
        </div>
    </div>
</template>


<script>
import { mapState } from "vuex";

import CallDialog from "@/components/always/call/CallDialog";
import CallPreview from "@/components/always/call/CallPreview";
import CallError from "@/components/always/call/CallError";

export default {
    computed: {
        ...mapState("call", ["currentCall", "callPreview", "createError"]),
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    components: {
        CallDialog,
        CallPreview,
        CallError,
    },
};
</script>

